var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcGuideQr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "qr_code"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Vector"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M2.25 8.25H8.25V2.25H2.25V8.25ZM3.75 3.75H6.75V6.75H3.75V3.75Z",
    fill: "#5E42E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.25 15.75H8.25V9.75H2.25V15.75ZM3.75 11.25H6.75V14.25H3.75V11.25Z",
    fill: "#5E42E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.75 2.25V8.25H15.75V2.25H9.75ZM14.25 6.75H11.25V3.75H14.25V6.75Z",
    fill: "#5E42E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 14.25H14.25V15.75H15.75V14.25Z",
    fill: "#5E42E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 9.75H9.75V11.25H11.25V9.75Z",
    fill: "#5E42E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75 11.25H11.25V12.75H12.75V11.25Z",
    fill: "#5E42E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M11.25 12.75H9.75V14.25H11.25V12.75Z",
    fill: "#5E42E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12.75 14.25H11.25V15.75H12.75V14.25Z",
    fill: "#5E42E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 12.75H12.75V14.25H14.25V12.75Z",
    fill: "#5E42E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M14.25 9.75H12.75V11.25H14.25V9.75Z",
    fill: "#5E42E8"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M15.75 11.25H14.25V12.75H15.75V11.25Z",
    fill: "#5E42E8"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcGuideQr);
export default __webpack_public_path__ + "static/media/ic_guide_qr.1cda8412caf5c6d763eef12363c5ef57.svg";
export { ForwardRef as ReactComponent };